import { InjectionToken } from '@angular/core';

export const DEMO_ENV_CONFIG = new InjectionToken('Demo Application config'); // it will be used for environment variable